import { DefinitionList, DefinitionListItem, Link } from "@funcional/react-ui";
import { IOAuth2Client } from "@sso/oauth2-clients/contracts";
import FormattedDuration from "react-intl-formatted-duration";

export function OAuth2ClientCard({ client }: { client: IOAuth2Client }) {
  return (
    <>
      <DefinitionList>
        <DefinitionListItem label="ID">{client.id}</DefinitionListItem>
        <DefinitionListItem label="Segredo">{client.secret}</DefinitionListItem>
        <DefinitionListItem label="Nome">{client.name}</DefinitionListItem>
        <DefinitionListItem label="Tipo">{client.type}</DefinitionListItem>
        <DefinitionListItem label="Revogado?">
          {client.revoked ? "Sim" : "Não"}
        </DefinitionListItem>
        <DefinitionListItem label="Duração do token">
          <div title={client.tokenExpiration + " segundos"}>
            <FormattedDuration
              seconds={client.tokenExpiration}
              unitDisplay="short"
              format="{days} {hours} {minutes} {seconds}"
            />
          </div>
        </DefinitionListItem>
        <DefinitionListItem label="Usuário fixo?">
          {client.user ? (
            <Link to={`/sso/users/${client.user.uuid}`}>
              {client.user.name}
            </Link>
          ) : (
            "Não"
          )}
        </DefinitionListItem>
        <DefinitionListItem label="URLs permitidas">
          {client.redirects?.length > 0 ? (
            <ul className="list-disc">
              {client.redirects.map((url) => (
                <li>{url}</li>
              ))}
            </ul>
          ) : (
            "-"
          )}
        </DefinitionListItem>
      </DefinitionList>
    </>
  );
}
